module.exports = __webpack_public_path__ + "static/img/audioOn.ff63e909.png";